// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "a.login-forgot {\n\tcursor: pointer;\n\tfont-size: .875rem;\n}\n.noty_body {\n\tmargin: 5px;\n\tcolor: black;\n}\n.noty_buttons {\n\tmargin: 4px;\n}\n.noty_close_with_click, .noty_close_with_button {\n\topacity: 1;\n\ttransition: opacity 0.5s ease-out;\n\tbackground-color: #eaeaea;\n\tcursor: pointer;\n\tmargin: 5px;\n\tborder-radius: 10px;\n\ttext-align: center;\n\tmargin-top: 50px;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
